module.exports = __webpack_public_path__ + "files/12ddf1eedcec522a8843a5d8271ae72d.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-1.png
// module id = 1461
// module chunks = 60